import { getSidebarBaseClasses, getSidebarLogoClasses } from "./constants";
import SidebarNavItem from "@surgia/ui/components/sidebar/sidebarNavItem";
import smallLogoIcon from "@surgia/ui/icons/sidebar/smallLogo.svg";
import UserProfile from "@surgia/ui/components/sidebar/userSidebar";
import { SidebarItem } from "@surgia/ui/components/sidebar/sidebarNavItem/constants";
import { useTranslation } from "react-i18next";
import logoIcon from "@surgia/ui/icons/sidebar/logo.svg";

export interface SidebarProps {
  items: SidebarItem[];
  className?: string;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
  onItemClick?: (item: SidebarItem) => void;
  onProfileClick?: (userProfile: any) => void;
  userProfile: any;
  onSignOut: () => void;
  userPermissions?: string[];
}

const SidebarLogo: React.FC<{
  isCollapsed: boolean;
}> = ({ isCollapsed }) => {
  return (
    <div className={getSidebarLogoClasses(isCollapsed)}>
      <div className="flex items-center justify-center">
        <img
          src={isCollapsed ? smallLogoIcon : logoIcon}
          alt="Logo"
          className="transition-all duration-300 ease-in-out max-[1200px]:hidden"
        />

        <img
          src={smallLogoIcon}
          alt="Logo"
          className="transition-all duration-300 ease-in-out hidden max-[1200px]:block "
        />
      </div>
    </div>
  );
};

const Sidebar: React.FC<SidebarProps> = ({
  items,
  className = "",
  isCollapsed = false,
  onToggleCollapse,
  onItemClick,
  userProfile,
  onSignOut,
  userPermissions = [],
}) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  // Combine classes with collapse state
  const classes = [getSidebarBaseClasses(isCollapsed), className].join(" ");
  return (
    <aside
      dir={isRTL ? "rtl" : "ltr"}
      className={`${classes} relative bg-red-500`}
      onClick={onToggleCollapse}
    >
      {/* Logo */}
      <SidebarLogo isCollapsed={isCollapsed} />

      {/* Navigation Items */}
      <nav className="flex-1">
        <ul className="gap-2">
          {items.map((item, index) => (
            <SidebarNavItem
              key={index}
              item={item}
              isCollapsed={isCollapsed}
              onItemClick={onItemClick}
              userPermissions={userPermissions}
            />
          ))}
        </ul>
      </nav>

      <UserProfile
        isCollapsed={isCollapsed}
        userProfile={userProfile}
        onSignOut={onSignOut}
      />
    </aside>
  );
};

export default Sidebar;
